<template>
  <div class="content">
    <div class="icon">
      <img :src="public_path + '/static/images/qiangsuccess.png'" alt="">
      <div class="type">已为您生成预订订单，请及时支付</div>
      <div class="order-no">预订单号：{{payOrder.order_no}}</div>
    </div>
    <div class="button">
      <button class="btn" @click="pay">去支付<i v-if="paying" class="weui-loading" style="width: 25px;height: 25px;margin-left: .1rem;"></i></button>
      <div class="count-count">支付倒计时：<span>{{down.value}}</span></div>
    </div>
    <div class="button-list">
      <div class="btn-item" @click="cancel">取消订单</div>
      <div class="btn-item btn-return" @click="returnIndex">返回首页</div>
    </div>
    <div class="footer">
      <img class="hint-img" :src="public_path + '/static/images/hint.png'" alt="">
      <div class="hint-1">支付成功后8个工作日内发货</div>
      <div class="hint-2">如有疑问请联系客服热线：13127832213</div>
      <div class="hint-1">（周一～周五 9:00～18:00）</div>
    </div>
    <div v-if="showDialog" class="dialog-item">
      <dialog-item :value="massage"></dialog-item>
    </div>
  </div>
</template>
<script>
import { payUrl, hostUrl } from '../http/env.js'
import { flashSaleCancelOrder, getOrderByNo, pay, k2CancelOrder } from '@/http/api'
import axios from 'axios'
import 'weui'
import weui from 'weui.js'
import _kjz from '../../static/js/chelun-kjz.js'
import _jl from '../../static/js/chaojijiaolian-jl.js'
import URL from '../../static/js/url.js'
import secondsFormat from '../util/secondsFormat'
import dialogItem from './dialog'

export default {
  props: ['payOrder', 'openid', 'isApp'],
  components: {
    'dialog-item': dialogItem
  },
  data () {
    return {
      showDialog: false,
      paying: false,
      public_path: process.env.PUBLICK_PATH,
      pay_order: this.payOrder,
      open_id: this.openid,
      isapp: URL.getQueryString('isapp') || '',
      count_down: 600,
      os: URL.getQueryString('os') || '',
      down: {
        value: '00:10:00',
        type: 'time'
      }
    }
  },
  methods: {
    showDia (massage) {
      this.showDialog = true
      this.massage = massage
      setTimeout(() => {
        this.showDialog = false
        this.massage = ''
      }, 1500)
    },
    getOrderByNo () {
      let product_id = JSON.parse(sessionStorage.order).product_id
      let data = {
        order_no: this.payOrder.order_no
      }
      if (product_id == 1) {
        data.type = 2
      }
      getOrderByNo(data).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.count_down = res.data.count_down
          this.computeTime()
          setInterval(this.computeTime, 1000)
        }
      })
    },
    pay () {
      if (this.paying) {
        return
      } else {
        this.paying = true
        setTimeout(() => this.paying = false, 5000)
        let channel = this.channel ? this.channel : _wx.isWx ? 'weixin_mp' : 'alipay'
        let callbackUrl = `${hostUrl}/frontend/sellSuccessed?os=${this.os}`
        console.log(this.isapp)
        if (_jl.isApp) {
          let param = {
            orderNum: this.payOrder.serial_number,
            channels: 'weixin,alipay',
            price: (this.payOrder.amount).toFixed(2),
            callbackUrl: '',
            success: (res) => {
              console.log('success', res)
              window.location.href = callbackUrl
            }
          }
          console.log(param)
          _kjz.appPay(param)
        } else {
          pay({
            c: 'order',
            v: 'pay2',
            serial_number: this.payOrder.serial_number,
            channel: channel,
            openid: this.openid,
            callback_url: callbackUrl
          }).then(res => {
            if (_wx.isWx) {
              _wx.pay(res.data.order_param, function () {
                window.location.href = res.data.order_param.callback_url
              })
            } else {
              window.location.href = res.data.url
            }
          }).catch(err => {
            console.log(err)
            this.paying = false
            this.showDia('请求失败')
          })
        }
      }
    },
    cancel () {
      let product_id = JSON.parse(sessionStorage.order).product_id
      if (product_id == 1) {
        k2CancelOrder({id: this.payOrder.id}).then(res => {
          console.log(res)
          if (res.code == 0) {
            localStorage.clear()
            window.location.href = `${hostUrl}/frontend/sellFail`
          } else {
            this.showDia(res.msg)
          }
        })
      } else {
        flashSaleCancelOrder({id: this.payOrder.id}).then(res => {
          console.log(res)
          if (res.code == 0) {
            localStorage.clear()
            window.location.href = `${hostUrl}/frontend/sellFail`
          } else {
            this.showDia(res.msg)
          }
        })
      }
      
    },
    returnIndex () {
      window.location.href = `${hostUrl}/frontend/sell`
    },
    computeTime () {
      this.count_down --
      let down = this.count_down
      if (down <= 0) {
        down = 0
        window.location.href = `${hostUrl}/frontend/sellFail`
      }
      this.down = secondsFormat(down)
    }
  },
  mounted () {
    this.getOrderByNo()
  }
}
</script>
<style lang="scss" scoped>
.content {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding-top: .58rem;
  .icon {
    text-align: center;
    img {
      width: 1.96rem;
      height: auto;
    }
    .type {
      text-align: center;
      font-size: .40rem;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
    }
    .order-no {
      margin-top: .32rem;
      font-size: .30rem;
      color: rgba(0, 0, 0, .7);
    }
  }
  .button {
    margin-top: .42rem;
    text-align: center;
    .btn {
      width: 7.10rem;
      height: .90rem;
      background: linear-gradient(32deg,rgba(235,96,50,1),rgba(235,74,56,1));
      border-radius: .12rem;
      line-height: .9rem;
      color: #fff;
      font-weight: 600;
      font-size: .34rem;
    }
    .count-count {
      margin-top: .3rem;
      margin-right: .3rem;
      text-align: right;
      font-size: .26rem;
      color: #000;
      span {
        color: #F73A1E;
      }
    }
  }
  .button-list {
    width: 7.10rem;
    margin: auto;
    display: -webkit-flex;
    display: flex;
    margin-top: .6rem;
    .btn-item {
      font-size: .34rem;
      text-align: center;
      width: 3.45rem;
      height: .9rem;
      line-height: .9rem;
      font-weight: 500;
      color: #ccc;
      border: 1px solid #ccc;
      border-radius: .12rem;
    }
    .btn-return {
      margin-left: .2rem;
    }
  }
  .footer {
    padding-bottom: 1rem;
    margin-top: 2rem;
    text-align: center;
    .hint-img {
      width: 5.3rem;
    }
    .hint-1 {
      font-size: .26rem;
      line-height: .40rem;
      opacity: 0.7;
      margin-top: .2rem;
    }
    .hint-2 {
      margin-top: .72rem;
      font-size: .30rem;
      font-weight:400;
      color: rgba(235, 124, 50, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/flashSalePay.vue